"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const actions_1 = require("../../actions");
const reducers_1 = require("../../reducers");
const Apps = ({ platformVersion, updateActivePopover, }) => {
    const appContainer = (appName, icon, href) => {
        return (React.createElement("div", { style: {
                display: 'inline-block',
                marginRight: appName !== 'Experiences' ? 8 : 0,
            } },
            React.createElement("a", { href: href, style: {
                    textDecoration: 'none',
                    cursor: 'default',
                }, target: "_blank", onClick: () => updateActivePopover('') },
                React.createElement("div", { style: {
                        height: 80,
                        width: 72,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    } },
                    React.createElement("div", { style: {
                            marginBottom: 8,
                        } }, icon),
                    React.createElement(src_1.Text, { text: appName, size: "small" })))));
    };
    const campaignsOrMessagesContainer = (platformVersion) => {
        if (platformVersion < 2) {
            return appContainer('Messages', src_1.MessagesIcon(), '/messages/');
        }
        else {
            return appContainer('Campaigns', src_1.CampaignsIcon(), '/campaigns/');
        }
    };
    return (React.createElement("div", { style: {
            padding: '32px 20px',
            width: 272,
            height: 256,
        } },
        React.createElement("div", { style: {
                marginBottom: 32,
            } },
            appContainer('Audience', src_1.AudienceIcon({
                width: '48',
                height: '48',
                viewBox: '0 0 72 72',
            }), '/audience/'),
            campaignsOrMessagesContainer(platformVersion),
            appContainer('Experiences', src_1.StudioIcon(), '/experiences/')),
        appContainer('Proximity', src_1.ProximityIcon(), '/proximity/'),
        appContainer('Settings', src_1.SettingsIcon(), '/settings/')));
};
const GridIconPopover = ({ user, activePopover, updateActivePopover, device, }) => {
    return (React.createElement(src_1.PopoverContainer, { id: "grid-icon-home-page", popoverProps: {
            placement: 'bottom-end',
        }, onClick: () => activePopover === 'grid-icon-home-page-popover'
            ? updateActivePopover('')
            : updateActivePopover('grid-icon-home-page-popover'), targetParent: "root", showPopover: activePopover === 'grid-icon-home-page-popover', style: {
            height: 20,
        } },
        React.createElement(src_1.GridIcon, { fill: src_1.charcoal, height: device === 'Desktop' ? '20' : '24', width: device === 'Desktop' ? '20' : '24', viewBox: "0 0 24 24" }),
        React.createElement(Apps, { platformVersion: user.platformVersion, updateActivePopover: updateActivePopover })));
};
const mapStateToProps = (state) => ({
    activePopover: reducers_1.getActivePopover(state),
    user: reducers_1.getUser(state),
});
const mapDispatchToProps = (dispatch) => {
    return {
        updateActivePopover: (activePopover) => dispatch(actions_1.updateActivePopover(activePopover)),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(GridIconPopover);
